<ngx-spinner
bdColor="rgba(0, 0, 0, 0.8)"
size="medium"
color="#fff"
type="ball-triangle-path"
fullScreen="true">
<p style="font-size: 20px; color: white">Cargando</p>
</ngx-spinner>
<router-outlet></router-outlet>
